import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import GooglePlusWidget from './GooglePlusWidget';
import i18n from 'kodyl-js/i18n/react';
import DocumentMeta from 'react-document-meta';

@i18n
class Contact extends Component {
  render() {
    const docMeta = {
      title: this.i18n('Contact us'),
      extend: true,
      auto: {
        ograph: true
      }
    };

    return (
      <DocumentMeta {...docMeta}>
        <Grid>
          <Row>
            <Col xs={12}>
              <h1>{this.i18n('Contact us')}</h1>
              <GooglePlusWidget />
              <p>
                Boligninja ApS
                <br />
                Niels Bohrs Vej 61
                <br />
                8660 Skanderborg
                <br />
                <br />
                CVR nr. DK 37 14 89 97
                <br />
                <br />
                E-mail:&nbsp;info (a) boligninja.dk
                <br />
                <br />
              </p>
              <p>
                Har du spørgsmål, så send en mail til kundeservice på info (a)
                boligninja.dk. Er du kunde, så hav venligst dit ordrenummer
                klar, så har vi lettere ved at finde dig i systemet.
              </p>
            </Col>
          </Row>
        </Grid>
      </DocumentMeta>
    );
  }
}

export default Contact;
